import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        accessToken: String
    }

    async connect() {
        // Lazy-load Mapbox custom elements on first use
        await import("@mapbox/search-js-web")
        if (this.accessTokenValue.includes("PlaceholderToken")) {
            console.warn("Mapbox Address Autocomplete: Using placeholder token. Features may be disabled.");
        }

        // Mapbox custom elements are robust and shouldn't block the input if they fail,
        // but we can listen for errors to help debug.
        this.element.addEventListener('error', (e) => {
            console.error("Mapbox Autocomplete Error:", e.detail);
        });
    }
}
